import React from "react";
import PRTPNavbar from "../Components/PRTPLanding/PRTPNavbar/PRTPNavbar";
import PRTPVision from "../Components/PRTPLanding/PRTPVision/PRTPVision";
import { Container, Row } from "react-bootstrap";
import PRTPMission from "../Components/PRTPLanding/PRTPMission/PRTPMission";
import Objective from "../Components/PRTPLanding/Objective/Objective";
import Coordinator from "../Components/PRTPLanding/Coordinator/Coordinator";
import PRTPTeacher from "../Components/PRTPLanding/PRTPTeacher/PRTPTeacher";
import CourseSummary from "../Components/PRTPLanding/CourseSummary/CourseSummary";
import CoursePlan from "../Components/PRTPLanding/CoursePlan/CoursePlan";
import PRTPAchiev from "../Components/PRTPLanding/PRTPAchievement/PRTPAchiev";
import Responsibilitie from "../Components/PRTPLanding/Responsibilitie/Responsibilitie";
import PRTPStudent from "../Components/PRTPLanding/PRTPStudent/PRTPStudent";
import AOS from "aos";
import "aos/dist/aos.css";
import CountDown from "../Components/PRTPLanding/CountDown/CountDown";
import ClosingHero from "../Components/PRTPLanding/ClosingHero/ClosingHero";
import { NextSeo } from "next-seo";
import Head from "next/head";
import Footer from "../Components/Shared/Footer/Footer";

const PRTPLanding = ({ isLoggedIn }) => {
  React.useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <NextSeo
        title="Professional Research Training Program (PRTP)"
        description="Be connected with the worldwide research hub."
        canonical="https://www.researchrider.com/prtp"
        openGraph={{
          url: "https://www.researchrider.com/prtp",
          title: "Professional Research Training Program (PRTP)",
          description: "Be connected with the worldwide research hub.",
          siteName: "Research Rider",
        }}
      />
      <Head>
        <meta
          name="keywords"
          content="best phd degrees,most popular phd degrees,best research, best phd in organisational psychology,top phd degrees	,best phd to pursue, best universities for gis and remote sensing in world, research coordinator certification, research online certification, market research courses, trials online course, online research courses, clinical research certification courses, research coordinator certification online, data management online course, cra course online, marketing research course, legal research courses online, research associate training near me, research associate course online, paid research studies, paid research studies near me, paid studies near me, research studies near me, research grants,autism research, the craft of research, stem cell products, practical research, advanced grant."
        />
      </Head>
      <Container>
        <Row className="justify-content-center">
          <PRTPNavbar isLoggedIn={isLoggedIn} />
          <PRTPVision />
          <PRTPMission />
          <Objective />
          <Coordinator />
          <PRTPTeacher />
          <CourseSummary />
          <CoursePlan />
          <PRTPAchiev />
          <Responsibilitie />
          <CountDown isLoggedIn={isLoggedIn} />
          <PRTPStudent isLoggedIn={isLoggedIn} />
          <ClosingHero isLoggedIn={isLoggedIn} />
        </Row>
      </Container>
      <Footer />
    </>
  );
};

export default PRTPLanding;
